export const getProp =
    <PropValue>() =>
    <PropName extends string>(key: PropName) => {
        type Props = undefined extends PropValue
            ? { [propName in PropName]?: PropValue }
            : { [propName in PropName]: PropValue };
        return (_: unknown, props: Props) => props?.[key] as PropValue;
    };

export const getStringProp = getProp<string>();
export const getStringOrNullProp = getProp<string | null>();
export const getStringOrUndefinedProp = getProp<string | undefined>();
export const getNumberProp = getProp<number>();
export const getBooleanProp = getProp<boolean>();
export const getStringArrayProp = getProp<string[]>();
